import styled from 'styled-components';

export const StyledSelectedTagRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
`;

export const StyledWeightDropdown = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  select {
    width: 5rem;
    height: 2.5rem;
    border-radius: 0.5rem;
    border: 1px solid ${({ theme }) => theme.colors.grey[400]};
    text-align: center;
    margin-left: 8px;
  }
`;

export const StyledTagLabel = styled.span<{ borderColor: string; backgroundColor: string; fontColor: string }>`
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.grey[400]};
  border-color: ${({ borderColor }) => borderColor || '#000'};
  border-style: solid;
  border-width: 1px;
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ fontColor }) => fontColor || '#000'};
  display: flex;
  align-items: center;
  padding: 0 8px;
`;

export const StyledRemoveBtn = styled.button<{ fontColor: string }>`
  margin-left: 8px;
  cursor: pointer;
  color: ${({ fontColor }) => fontColor || '#000'};
  background: none;
  border: none;
  padding: 0;
`;
